import { create } from "zustand";

interface ModalsStateStore {
    addModalToOpenModalsArray: (modalId: string) => void;
    hasOpenModals: () => boolean;
    openModalsArray: string[];
    removeModalFromOpenModalsArray: (modalId: string) => void;
}

export const useModalsStateStore = create<ModalsStateStore>((set, get) => ({
    openModalsArray: [],
    hasOpenModals: () => get().openModalsArray.length > 0,
    addModalToOpenModalsArray: (modalId: string) => {
        set((state) => ({
            openModalsArray: [...state.openModalsArray, modalId],
        }));
    },
    removeModalFromOpenModalsArray: (modalId: string) => {
        set((state) => ({
            openModalsArray: state.openModalsArray.filter(
                (modalIdInArray) => modalIdInArray !== modalId,
            ),
        }));
    },
}));
